import { HttpClient, HttpParams } from '@angular/common/http';
import { NgModule, Injector } from '@angular/core';
import { takeWhile, finalize, map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
class NgxPagedListModule {
    constructor(_injector) {
        this._injector = _injector;
        NgxPagedListModule.injector = _injector;
    }
}
NgxPagedListModule.ɵfac = function NgxPagedListModule_Factory(t) { return new (t || NgxPagedListModule)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
NgxPagedListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxPagedListModule });
NgxPagedListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
NgxPagedListModule.injector = null;
NgxPagedListModule.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPagedListModule, [{
        type: NgModule,
        args: [{
                imports: []
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class PagedListService {
    constructor(options) {
        this.itens = [];
        this.loading = false;
        this.error = false;
        this.totalPages = 1;
        this.totalRecords = 0;
        this.filterData = {};
        this.http = NgxPagedListModule.injector.get(HttpClient);
        this.url = options.url || '';
        this.sortField = options.sortField || 'Id';
        this.sortType = options.sortType || 'asc';
        this.pageIndex = options.pageIndex || 1;
        this.pageSize = options.pageSize || 20;
        this.onLoadFinished = options.onLoadFinished;
        this.onLoadStarts = options.onLoadStarts;
        this.isAlive = options.isAlive == null ? true : options.isAlive;
        this.isPost = options.isPost;
        this.options = options;
        if (!this.url) {
            throw (new Error('URL is empty'));
        }
    }
    searchData(data) {
        this.filterData = data ? Object.assign({}, data) : this.filterData;
        data = data || {};
        Object.assign(data, this.filterData);
        data.pageSize = this.pageSize;
        data.pageIndex = this.pageIndex;
        data.sortField = this.sortField;
        data.sortType = this.sortType;
        return data;
    }
    reset() {
        this.filterData = {};
        this.sortField = this.options.sortField || 'Id';
        this.sortType = this.options.sortType || 'asc';
        this.pageIndex = 1;
    }
    createHttpParams(params) {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(param => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });
        return httpParams;
    }
    load(data, isSearch = false, clear = false) {
        if (isSearch || clear) {
            this.reset();
        }
        if (this.pageIndex >= 1 || this.pageIndex <= (this.totalPages || 1)) {
            this.loading = true;
            this.itens = [];
            let observable = this.isPost
                ? this.http.post(this.url, this.searchData(data))
                : this.http.get(`${this.url}`, {
                    params: this.createHttpParams(this.searchData(data))
                });
            if (this.onLoadStarts) {
                this.onLoadStarts();
            }
            observable.pipe(takeWhile(() => this.isAlive), finalize(() => this.loading = false), map(response => response.data ? response.data : response)).subscribe(response => {
                this.itens = response.itens;
                this.totalPages = response.totalPages;
                this.totalRecords = response.totalRecords;
                this.error = false;
                this.loading = false;
                if (this.onLoadFinished) {
                    this.onLoadFinished();
                }
            }, error => {
                this.error = true;
                this.loading = false;
                if (this.onLoadFinished) {
                    this.onLoadFinished();
                }
            });
        }
    }
    sort(field) {
        this.sortType = this.sortField != field ? 'asc' : this.sortType == 'asc' ? 'desc' : 'asc';
        this.sortField = field;
        this.pageIndex = 1;
        this.load();
    }
    hasPreviousPage() {
        return this.pageIndex > 1;
    }
    hasNextPage() {
        return this.pageIndex < this.totalPages;
    }
    goToFirstPage() {
        if (this.hasPreviousPage()) {
            this.pageIndex = 1;
            this.load();
        }
    }
    goToPreviousPage() {
        if (this.hasPreviousPage()) {
            this.pageIndex = this.pageIndex - 1;
            this.load();
        }
    }
    goToNextPage() {
        if (this.hasNextPage()) {
            this.pageIndex = this.pageIndex + 1;
            this.load();
        }
    }
    goToLastPage() {
        if (this.hasNextPage()) {
            this.pageIndex = this.totalPages;
            this.load();
        }
    }
}

class PagedListOptions {
    constructor() {
        this.isAlive = true;
        this.isPost = false;
    }
}

/*
 * Public API Surface of ngx-paged-list
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxPagedListModule, PagedListOptions, PagedListService };

